
import { CAMPAIGNS, CAMPAIGNS_DATA, CAMPAIGNS_CHARGES, INTEREST, GET_TRANSACTION_HISTORY} from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import {changeParamsToQuery} from './commonFn';

export class CampaignService {

  static instance;
  static getInstance() {
    if (!CampaignService.instance) {
      CampaignService.instance = new CampaignService();
    }
    return CampaignService.instance;
  }
  fetchCampaigns = async (params) => {
    let newsResponse = await Api.get(`${CAMPAIGNS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  fetchCampaignDetails = async (params) => {
    let newsResponse = await Api.get(`${CAMPAIGNS_DATA.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  changeStatus = async (params) => {
    let newsResponse = await Api.patch(`${CAMPAIGNS.URL}`, params);
    return newsResponse;
  }



  fetchCharges = async (params) => {
    let newsResponse = await Api.get(`${CAMPAIGNS_CHARGES.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  saveCharges = async (params) => {
  
    let newsResponse = (params.id)?await Api.put(`${CAMPAIGNS_CHARGES.URL}`, params):await Api.post(`${CAMPAIGNS_CHARGES.URL}`, params);
    return newsResponse;
  }


  fetchInterest = async (params) => {
    let newsResponse = await Api.get(`${INTEREST.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  saveInterest = async (params) => {
    let newsResponse = (params.id)?await Api.put(`${INTEREST.URL}`, params):await Api.post(`${INTEREST.URL}`, params);
    return newsResponse;
  }

  deleteInterest = async (params) => {
    console.log('params--',params)
    let newsResponse = await Api.delete(`${INTEREST.URL}`, params);
    return newsResponse;
  }
 
  fetchTransactionHistory = async (params) => {
    let newsResponse = await Api.get(`${GET_TRANSACTION_HISTORY.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }
  
}

